import {
    type LoginResponseType,
    type LoginRequestType
} from "./types";
import axios from "axios";
import {
    storage
} from "../../../../storage";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const Login = async (params: LoginRequestType): Promise<LoginResponseType> => {
    return await axios(`${SERVER_ADDRESS}/authentication/login`, {
        method: "POST",
        headers: getHeaders(),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                if (res.data.payload && !res.data.payload.isDeleted) {
                    storage.set("accessToken", res.data.payload.accessToken);
                    storage.set("refreshToken", res.data.payload.refreshToken);
                }

                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default Login;
